<header class="bg-white shadow sticky top-0 z-10">
  <div class="mx-auto max-w-7xl px-4 py-4 sm:px-6 lg:px-8">
    <div class="flex items-start justify-between gap-3">
      <div class="min-w-0">
        <h1 class="truncate text-xl font-semibold tracking-tight text-gray-900 md:text-2xl" *ngIf="user?.roles?.includes('csr')">
          Customer Service Dashboard
        </h1>
        <h1 class="truncate text-xl font-semibold tracking-tight text-gray-900 md:text-2xl" *ngIf="user?.roles?.includes('gm')">
          General Manager Dashboard
        </h1>
        <h1 class="truncate text-xl font-semibold tracking-tight text-gray-900 md:text-2xl" *ngIf="user?.roles?.includes('estimator')">
          Estimator Dashboard
        </h1>
        <h1 class="truncate text-xl font-semibold tracking-tight text-gray-900 md:text-2xl" *ngIf="user?.roles?.includes('parts coordinator')">
          Parts Coordinator Dashboard
        </h1>
        <h1 class="truncate text-xl font-semibold tracking-tight text-gray-900 md:text-2xl" *ngIf="user?.roles?.includes('porter')">
          Porter Dashboard
        </h1>
        <button type="button"
                (click)="refreshDashboard()"
                class="mt-1 inline-flex h-11 items-center gap-1.5 rounded-full pr-2 text-sm text-gray-500 transition-colors duration-150 hover:text-gray-800 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-indigo-500"
                [attr.aria-label]="'Refresh dashboard. ' + updatedAgoLabel">
          <svg class="h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15" />
          </svg>
          <span class="md:hidden">{{ updatedAgoLabel }}</span>
          <span class="hidden md:inline">Updated {{ lastUpdateTime | date:'shortTime' }}</span>
        </button>
      </div>

      <div class="hidden shrink-0 items-center gap-3 md:flex">
        <button
          *ngIf="canManageDistributionGroups()"
          type="button"
          (click)="openDistributionGroupsManager()"
          class="inline-flex items-center rounded-md border border-gray-300 bg-white px-3 py-2 text-sm font-semibold text-gray-800 transition-colors duration-200 hover:bg-gray-50">
          Distribution groups
        </button>
        <button type="button"
                (click)="openAddRequestSlideOut()"
                class="inline-flex items-center rounded-md bg-gray-900 px-3 py-2 text-sm font-semibold text-white transition-colors duration-200 hover:bg-gray-800">
          <svg class="mr-1.5 h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 4v16m8-8H4" />
          </svg>
          {{ addBtnName() }}
        </button>
      </div>
    </div>



    <!-- Metrics Row -->
    <div class="grid grid-cols-2 gap-4 mt-4"
         [class.metrics-collapsed]="!metricsExpanded"
         [ngClass]="{
           'md:grid-cols-3': user?.roles.includes('csr') || user?.roles.includes('porter'),
           'md:grid-cols-4': !user?.roles.includes('gm') && !user?.roles.includes('csr') && !user?.roles.includes('porter'),
           'md:grid-cols-6': user?.roles.includes('gm')
         }">


      <!-- Tech Queue Card -->
    <div class="bg-white p-3 rounded-lg shadow-sm border border-gray-100" *ngIf="isUserAssigned">
      <div class="flex items-center">
        <div class="p-2 bg-green-100 rounded-lg">
          <svg class="w-4 h-4 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
          </svg>
        </div>
        <div class="ml-3">
          <span class="text-lg font-semibold text-green-600">{{newTechQueueCount || 0}}</span>
          <p class="text-xs text-gray-500">Queue of Tech Requests</p>
        </div>
      </div>
    </div>

      <!-- Active Tasks Card -->
      <div class="bg-white p-3 rounded-lg shadow-sm border border-gray-100" *ngIf="!user?.roles.includes('gm')">
        <div class="flex items-center">
          <div class="p-2 bg-green-100 rounded-lg">
            <svg class="w-4 h-4 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
            </svg>
          </div>
          <div class="ml-3">
            <span class="text-lg font-semibold text-green-600">{{getTechRequestsCount() || 0}}</span>
            <p class="text-xs text-gray-500">My Tech Requests</p>
          </div>
        </div>
      </div>

      <!-- GM-specific cards - hidden on mobile -->
      <div class="hidden md:contents" *ngIf="user?.roles.includes('gm')">
        <!-- All Tech Requests Card -->
        <div class="bg-white p-3 rounded-lg shadow-sm border border-gray-100">
        <div class="flex items-center">
          <div class="p-2 bg-green-100 rounded-lg">
            <svg class="w-4 h-4 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
            </svg>
          </div>
          <div class="ml-3">
            <span class="text-lg font-semibold text-green-600">{{allTechRequestsCount_cardCount || 0}}</span>
            <p class="text-xs text-gray-500">All Tech Requests</p>
          </div>
        </div>
      </div>
      
        <!-- Pending Vendor Approvals Card -->
        <div class="bg-white p-3 rounded-lg shadow-sm border border-gray-100 cursor-pointer hover:shadow-md transition-shadow"
             [routerLink]="['/vendor-approval']">
          <div class="flex items-center">
            <div class="p-2 bg-orange-100 rounded-lg">
              <svg class="w-4 h-4 text-orange-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" />
              </svg>
            </div>
            <div class="ml-3">
              <span class="text-lg font-semibold text-orange-600">{{pendingVendorApprovalsCount || 0}}</span>
              <p class="text-xs text-gray-500">Vendor Approvals</p>
            </div>
          </div>
        </div>
      </div>
      
      <!-- Monthly Closing Goal Card (GM Only) -->
      <div class="bg-white p-3 rounded-lg shadow-sm border border-gray-100" *ngIf="user?.roles.includes('gm')">
        <div class="flex items-center">
          <div class="p-2 bg-blue-100 rounded-lg">
            <svg class="w-4 h-4 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
            </svg>
          </div>
          <div class="ml-3">
            <span class="text-lg font-semibold text-blue-600">${{ actualClosed | number:'1.0-0'}}</span>
            <p class="text-xs text-gray-500">Remaining to Goal</p>
          </div>
        </div>
      </div>

      <!-- Remaining Working Days Card (GM Only) -->
      <div class="bg-white p-3 rounded-lg shadow-sm border border-gray-100" *ngIf="user?.roles.includes('gm')">
        <div class="flex items-center">
          <div class="p-2 bg-purple-100 rounded-lg">
            <svg class="w-4 h-4 text-purple-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
            </svg>
          </div>
          <div class="ml-3">
            <span class="text-lg font-semibold text-purple-600">{{remainingWorkDays}}</span>
            <p class="text-xs text-gray-500">Working Days Left</p>
          </div>
        </div>
      </div>

      <!-- Overdue Tasks Card (Non-GM) -->
       <div class="bg-white p-3 rounded-lg shadow-sm border border-gray-100" 
       *ngIf="!user?.roles.includes('gm') && !user?.roles.includes('csr') && !user?.roles.includes('porter')">
        <div class="flex items-center">
          <div class="p-2 bg-red-100 rounded-lg">
            <svg class="w-4 h-4 text-red-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
            </svg>
          </div>
          <div class="ml-3">
            <span class="text-lg font-semibold text-red-600">{{ overDueTechRequestsByRoleCount || 0}}</span>
            <p class="text-xs text-gray-500">Overdue Tech Requests</p>
          </div>
        </div>
      </div>

      <!-- Incoming Tasks Card -->
      <div class="mobile-extra-metric bg-white p-3 rounded-lg shadow-sm border border-gray-100 cursor-pointer hover:shadow-md transition-shadow md:block"
           (click)="setActiveButton(myTasksButton, 'IR'); updateView()">
        <div class="flex items-center">
          <div class="p-2 bg-blue-100 rounded-lg">
            <svg class="w-4 h-4 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7" />
            </svg>
          </div>
          <div class="ml-3">
            <span class="text-lg font-semibold text-blue-600">{{incoming_cardCount || 0}}</span>
            <p class="text-xs text-gray-500">Incoming Requests</p>
          </div>
        </div>
      </div>

      <!-- Outgoing Tasks Card -->
      <div class="mobile-extra-metric bg-white p-3 rounded-lg shadow-sm border border-gray-100 cursor-pointer hover:shadow-md transition-shadow md:block"
           [ngClass]="{'hidden': user?.roles?.includes('csr') || user?.roles?.includes('porter')}"
           (click)="setActiveButton(myRequestButton, 'MR'); updateView()">
        <div class="flex items-center">
          <div class="p-2 bg-yellow-100 rounded-lg">
            <svg class="w-4 h-4 text-yellow-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 15l7-7 7 7" />
            </svg>
          </div>
          <div class="ml-3">
            <span class="text-lg font-semibold text-yellow-600">{{outgoing_cardCount || 0}}</span>
            <p class="text-xs text-gray-500">Outgoing Requests</p>
          </div>
        </div>
      </div>
    </div>

    <button
      type="button"
      class="mt-3 inline-flex h-11 w-full items-center justify-center rounded-lg border border-gray-300 bg-white text-sm font-semibold text-gray-800 md:hidden"
      (click)="metricsExpanded = !metricsExpanded"
      [attr.aria-expanded]="metricsExpanded">
      {{ mobileFlowToggleLabel }}
    </button>


    <!-- Navigation Tabs -->
    <div class="mt-4 border-b border-gray-100">
      <!-- Mobile Tabs -->
      <div class="block md:hidden overflow-x-auto -mb-px hide-scrollbar">
        <nav class="flex space-x-2 px-1 py-2 min-w-max">
          <button *ngIf="isUserAssigned" 
                  #techRequestsUnAssigned 
                  type="button" 
                  (click)="setActiveButton(techRequestsUnAssigned, 'CTR'); updateView()" 
                  class="flex items-center px-4 py-2.5 rounded-lg text-sm font-medium transition-all duration-200"
                  [ngClass]="{
                    'bg-black text-white shadow-sm': activeFilter === 'CTR',
                    'bg-gray-100 text-gray-700': activeFilter !== 'CTR'
                  }">
            <span>Tech Queue</span>
            <span *ngIf="newTechQueueCount > 0" 
                  class="ml-1.5 px-1.5 py-0.5 rounded-full text-xs bg-red-500 text-white min-w-[20px] text-center">
              {{newTechQueueCount}}
            </span>
          </button>

          <button *ngIf="!user?.roles.includes('gm')" 
                  #techRequestsButton 
                  type="button" 
                  (click)="setActiveButton(techRequestsButton, (user?.roles.includes('csr') ? 'CSR' : user?.roles.includes('porter') ? 'PR' : 'TR')); updateView()" 
                  class="flex items-center px-4 py-2.5 rounded-lg text-sm font-medium transition-all duration-200"
                  [ngClass]="{
                    'bg-black text-white shadow-sm': activeFilter === 'TR',
                    'bg-gray-100 text-gray-700': activeFilter !== 'TR'
                  }">
            <span>My Tech</span>
            <span *ngIf="getTechRequestsReadCount() > 0" 
                  class="ml-1.5 px-1.5 py-0.5 rounded-full text-xs bg-red-500 text-white min-w-[20px] text-center">
              {{getTechRequestsReadCount()}}
            </span>
          </button>

          <button *ngIf="user?.roles.includes('gm')" 
                  #techRequestsButton 
                  type="button" 
                  (click)="setActiveButton(techRequestsButton, 'GMC'); updateView()" 
                  class="flex items-center px-4 py-2.5 rounded-lg text-sm font-medium transition-all duration-200"
                  [ngClass]="{
                    'bg-black text-white shadow-sm': activeFilter === 'GMC',
                    'bg-gray-100 text-gray-700': activeFilter !== 'GMC'
                  }">
            <span>All Tech</span>
            <span *ngIf="allTechRequestsCount > 0" 
                  class="ml-1.5 px-1.5 py-0.5 rounded-full text-xs bg-red-500 text-white min-w-[20px] text-center">
              {{allTechRequestsCount}}
            </span>
          </button>

          <button #myTasksButton 
                  type="button" 
                  (click)="setActiveButton(myTasksButton, 'IR'); updateView()" 
                  class="flex items-center px-4 py-2.5 rounded-lg text-sm font-medium transition-all duration-200"
                  [ngClass]="{
                    'bg-black text-white shadow-sm': activeFilter === 'IR',
                    'bg-gray-100 text-gray-700': activeFilter !== 'IR'
                  }">
            <span>Incoming</span>
            <span *ngIf="newIncomingTasksCount > 0" 
                  class="ml-1.5 px-1.5 py-0.5 rounded-full text-xs bg-red-500 text-white min-w-[20px] text-center">
              {{newIncomingTasksCount}}
            </span>
          </button>

          <button #myRequestButton 
                  type="button" 
                  (click)="setActiveButton(myRequestButton, 'MR'); updateView()" 
                  class="flex items-center px-4 py-2.5 rounded-lg text-sm font-medium transition-all duration-200"
                  [ngClass]="{
                    'bg-black text-white shadow-sm': activeFilter === 'MR',
                    'bg-gray-100 text-gray-700': activeFilter !== 'MR'
                  }">
            <span>Outgoing</span>
            <span *ngIf="newOutgoingTasksCount > 0" 
                  class="ml-1.5 px-1.5 py-0.5 rounded-full text-xs bg-red-500 text-white min-w-[20px] text-center">
              {{newOutgoingTasksCount}}
            </span>
          </button>
        </nav>
      </div>

      <!-- Desktop Tabs -->
      <div class="hidden md:flex flex-wrap -mb-px space-x-4">
        <!-- Tech Queue Button with Badge -->
    <button *ngIf="isUserAssigned" 
            #techRequestsUnAssigned 
            type="button" 
            (click)="setActiveButton(techRequestsUnAssigned, 'CTR'); updateView()" 
                class="relative inline-flex items-center px-1 py-2 text-sm font-medium transition-all duration-200 focus:outline-none border-0 border-b-2"
            [ngClass]="{
                  'border-black text-black': activeFilter === 'CTR',
                  'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300': activeFilter !== 'CTR'
            }">
      Tech Queue
      <span *ngIf="newTechQueueCount > 0" 
            class="ml-2 inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium bg-red-500 text-white">
        {{ newTechQueueCount }} unread
      </span>
    </button>

        <!-- My Tech Requests Button with Badge -->
    <button *ngIf="!user?.roles.includes('gm')" 
            #techRequestsButton 
            type="button" 
                (click)="setActiveButton(techRequestsButton, (user?.roles.includes('csr') ? 'CSR' : user?.roles.includes('porter') ? 'PR' : 'TR')); updateView()" 
                class="relative inline-flex items-center px-1 py-2 text-sm font-medium transition-all duration-200 focus:outline-none border-0 border-b-2"
            [ngClass]="{
                  'border-black text-black': activeFilter === 'TR',
                  'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300': activeFilter !== 'TR'
            }">
      My Tech Requests
      <span *ngIf="getTechRequestsReadCount() > 0" 
            class="ml-2 inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium bg-red-500 text-white">
        {{ getTechRequestsReadCount() }} unread
      </span>
    </button>

        <!-- All Tech Requests Card (GM) -->
    <button *ngIf="user?.roles.includes('gm')" 
                #techRequestsButton 
            type="button" 
                (click)="setActiveButton(techRequestsButton, 'GMC'); updateView()" 
                class="relative inline-flex items-center px-1 py-2 text-sm font-medium transition-all duration-200 focus:outline-none border-0 border-b-2"
            [ngClass]="{
                  'border-black text-black': activeFilter === 'GMC',
                  'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300': activeFilter !== 'GMC'
            }">
      All Tech Requests
          <span *ngIf="allTechRequestsCount > 0" 
            class="ml-2 inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium bg-red-500 text-white">
            {{ allTechRequestsCount }} unread
      </span>
    </button>

        <!-- Incoming Tasks Button with Badge -->
    <button #myTasksButton 
            type="button" 
                (click)="setActiveButton(myTasksButton, 'IR'); updateView()" 
                class="relative inline-flex items-center px-1 py-2 text-sm font-medium transition-all duration-200 focus:outline-none border-0 border-b-2"
            [ngClass]="{
                  'border-black text-black': activeFilter === 'IR',
                  'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300': activeFilter !== 'IR'
            }">
          Incoming
      <span *ngIf="newIncomingTasksCount > 0" 
            class="ml-2 inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium bg-red-500 text-white">
        {{ newIncomingTasksCount }} unread
      </span>
    </button>

        <!-- Outgoing Tasks Button with Badge -->
        <button #myRequestButton 
            type="button" 
                (click)="setActiveButton(myRequestButton, 'MR'); updateView()" 
                class="relative inline-flex items-center px-1 py-2 text-sm font-medium transition-all duration-200 focus:outline-none border-0 border-b-2"
            [ngClass]="{
                  'border-black text-black': activeFilter === 'MR',
                  'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300': activeFilter !== 'MR'
            }">
          Outgoing
      <span *ngIf="newOutgoingTasksCount > 0" 
            class="ml-2 inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium bg-red-500 text-white">
        {{ newOutgoingTasksCount }} unread
      </span>
    </button>
  </div>
</div>
  </div>
</header>

<button type="button"
        (click)="openAddRequestSlideOut()"
        class="fixed bottom-16 right-4 z-[60] inline-flex h-14 items-center gap-2 rounded-full bg-gray-900 pl-4 pr-5 text-sm font-semibold text-white shadow-[0_10px_24px_-8px_rgba(17,24,39,0.45)] transition-[transform,background-color] duration-150 ease-[cubic-bezier(0.23,1,0.32,1)] hover:bg-gray-800 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-indigo-500 focus-visible:ring-offset-2 active:scale-[0.97] md:hidden">
  <svg class="h-5 w-5" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 4v16m8-8H4" />
  </svg>
  Create
  <span class="sr-only">Request</span>
</button>

<main class="pb-24 pt-4 md:pb-0">
  <div class="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
    <!-- Spinner -->
    <div *ngIf="isLoading" class="flex justify-center items-center h-64">
      <div class="animate-spin rounded-full h-16 w-16 border-t-4 border-blue-500"></div>
    </div>

    <!-- Fixed to the viewport (under app nav z) so scroll never leaves content uncovered -->
    <div *ngIf="isPaginationLoading"
         class="fixed inset-0 z-[55] flex items-center justify-center bg-slate-900/30 backdrop-blur-[2px]"
         role="status"
         aria-live="polite"
         aria-busy="true"
         [@fadeInOut]>
      <div class="flex flex-col items-center rounded-xl bg-white px-6 py-5 shadow-xl shadow-slate-900/15 ring-1 ring-slate-900/5">
        <div class="h-9 w-9 animate-spin rounded-full border-2 border-slate-200 border-t-slate-900" aria-hidden="true"></div>
        <p class="mt-3 text-sm font-medium text-slate-800">Loading requests…</p>
      </div>
    </div>

    <!-- Task List Content -->
    <div *ngIf="!isLoading && (tasks$ | async) as tasks" [@fadeInOut]>
      <!-- Add request type filter with clear button -->
      <!-- <div class="mb-4 flex items-center space-x-2">
        <div class="relative">
          <select 
            [(ngModel)]="selectedRequestType" 
            (change)="onRequestTypeChange()"
            [disabled]="isFilterLoading"
            class="block w-48 px-3 py-2 text-sm border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 disabled:bg-gray-100 disabled:cursor-not-allowed">
            <option value="">{{selectedRequestName}}</option>
            <option *ngFor="let request of availableRequestTypes" [value]="request._id">
              {{request.name}} ({{getRequestTypeCount(request._id)}})
            </option>
          </select>
         
          <div *ngIf="isFilterLoading" class="absolute right-2 top-1/2 transform -translate-y-1/2">
            <div class="animate-spin rounded-full h-4 w-4 border-b-2 border-indigo-500"></div>
          </div>
        </div>
        <button 
          *ngIf="selectedRequestType"
          (click)="clearRequestTypeFilter()"
          [disabled]="isFilterLoading"
          class="inline-flex items-center px-3 py-2 border border-gray-300 shadow-sm text-sm leading-4 font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 disabled:bg-gray-100 disabled:cursor-not-allowed">
          Clear Filter
        </button>
      </div> -->

      <!-- No results message -->
      <!-- <div *ngIf="selectedRequestType && tasks.length === 0" class="text-center py-4 text-gray-500">
        No tasks found for the selected request type
      </div> -->

      <div class="mt-8 flow-root">
        <ng-template #noDataa>
          <div class="text-center">
            <svg class="mx-auto h-12 w-12 text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor" aria-hidden="true">
              <path vector-effect="non-scaling-stroke" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 13h6m-3-3v6m-9 1V7a2 2 0 012-2h6l2 2h6a2 2 0 012 2v8a2 2 0 01-2 2H5a2 2 0 01-2-2z" />
            </svg>
            <h3 class="mt-2 text-sm font-semibold text-gray-900">No Request(s) Found</h3>
            <div class="mt-6">
              <button (click)="openAddRequestSlideOut()" type="button" class="inline-flex items-center rounded-md bg-black px-3 py-2 text-center text-sm font-semibold text-white shadow-sm hover:bg-gray-800 focus-visible:outline focus-visible:outline-2 focus-visible:outline-gray-800">
                <svg class="-ml-0.5 mr-1.5 h-5 w-5" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                  <path d="M10.75 4.75a.75.75 0 00-1.5 0v4.5h-4.5a.75.75 0 000 1.5h4.5v4.5a.75.75 0 001.5 0v-4.5h4.5a.75.75 0 000-1.5h-4.5v-4.5z" />
                </svg>
                New Request
              </button>
            </div>
          </div>
        </ng-template>

        <div class="mx-auto max-w-7xl" *ngIf="!noData; else noDataa">
          <!-- Compact top pager — page without scrolling past the list first -->
          <div *ngIf="totalPages > 1"
               id="task-list-top"
               class="mb-3 flex scroll-mt-40 items-center justify-between gap-3">
            <button
              type="button"
              (click)="previousPage()"
              [disabled]="currentPage === 1 || isPaginationLoading"
              class="inline-flex h-9 items-center gap-1.5 rounded-md px-2.5 text-sm font-medium transition-[transform,background-color,color] duration-150 ease-[cubic-bezier(0.23,1,0.32,1)] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-indigo-500 active:scale-[0.97] disabled:cursor-not-allowed disabled:opacity-40 disabled:active:scale-100"
              [ngClass]="currentPage === 1 || isPaginationLoading
                ? 'text-gray-400'
                : 'text-gray-700 hover:bg-gray-100 hover:text-gray-900'">
              <svg class="h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 19l-7-7 7-7" />
              </svg>
              Previous
            </button>

            <p class="tabular-nums text-sm text-gray-600" aria-live="polite">
              <span class="font-medium text-gray-900">{{ currentPage }}</span>
              <span class="mx-1.5 text-gray-400">/</span>
              <span>{{ totalPages }}</span>
            </p>

            <button
              type="button"
              (click)="nextPage()"
              [disabled]="currentPage === totalPages || isPaginationLoading"
              class="inline-flex h-9 items-center gap-1.5 rounded-md px-2.5 text-sm font-medium transition-[transform,background-color,color] duration-150 ease-[cubic-bezier(0.23,1,0.32,1)] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-indigo-500 active:scale-[0.97] disabled:cursor-not-allowed disabled:opacity-40 disabled:active:scale-100"
              [ngClass]="currentPage === totalPages || isPaginationLoading
                ? 'text-gray-400'
                : 'text-gray-700 hover:bg-gray-100 hover:text-gray-900'">
              Next
              <svg class="h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7" />
              </svg>
            </button>
          </div>

          <div class="relative min-h-[50px] space-y-2 overflow-hidden" [@taskList]="tasks.length">
            <!-- Task Cards -->
            <div *ngFor="let task of tasks; trackBy: trackByFn" 
                 class="bg-white rounded-lg shadow-sm border border-gray-200 overflow-hidden transition-all duration-200 hover:shadow-md relative w-full"
                 [ngClass]="{
                   'border-l-4': true,
                   'border-l-red-500': task.isUrgent,
                   'border-l-blue-400': !task.isUrgent,
                   'bg-opacity-50': task.isRead,
                   'bg-gray-50': task.isRead,
                   'shadow-md': !task.isRead
                 }">
              <!-- Main Task Content -->
              <div class="p-4">
                <!-- Mobile Layout -->
                <div class="md:hidden">
                  <!-- Top Row: Date, Urgent, and Status -->
                  <div class="flex items-center justify-between mb-2">
                    <div class="flex items-center space-x-2">
                      <span class="text-xs text-gray-500">{{ formatDate(task.createdAt) }}</span>
                      <!-- Status Indicators -->
                      <div class="flex items-center space-x-1">
                        <!-- Urgent Indicator -->
                      <span *ngIf="task.isUrgent" title="Urgent Request">
                        <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" viewBox="0 0 24 24" fill="red" stroke="black" stroke-width="2">
                          <circle cx="12" cy="12" r="10" stroke="black" stroke-width="2" fill="red" />
                          <line x1="12" y1="8" x2="12" y2="14" stroke="white" stroke-width="2" />
                          <line x1="12" y1="16" x2="12" y2="18" stroke="white" stroke-width="2" />
                        </svg>
                      </span>
                        <!-- Read/Unread Status -->
                        <span class="inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium"
                              [ngClass]="{
                                'bg-blue-100 text-blue-800': !task.isRead,
                                'bg-gray-100 text-gray-600': task.isRead
                              }">
                          <svg *ngIf="!task.isRead" xmlns="http://www.w3.org/2000/svg" class="h-3 w-3 mr-1" viewBox="0 0 20 20" fill="currentColor">
                            <path d="M10 12a2 2 0 100-4 2 2 0 000 4z" />
                            <path fill-rule="evenodd" d="M.458 10C1.732 5.943 5.522 3 10 3s8.268 2.943 9.542 7c-1.274 4.057-5.064 7-9.542 7S1.732 14.057.458 10zM14 10a4 4 0 11-8 0 4 4 0 018 0z" clip-rule="evenodd" />
                          </svg>
                          <svg *ngIf="task.isRead" xmlns="http://www.w3.org/2000/svg" class="h-3 w-3 mr-1" viewBox="0 0 20 20" fill="currentColor">
                            <path fill-rule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clip-rule="evenodd" />
                          </svg>
                          {{ task.isRead ? 'Read' : 'Unread' }}
                        </span>
                      </div>
                    </div>
                    <div class="flex items-center space-x-2">
                      <span class="text-xs text-gray-500">{{ task.taskCompleted ? '----' : task.timeSinceRequest }}</span>
                      <!-- Add this inside the right-aligned div in the top row -->
                      <ng-container *ngIf="task.request?.name === 'Blueprint' && user?.roles.includes('gm')">
                        <button
                          class="ml-2 p-1 rounded-full bg-blue-100 hover:bg-blue-200 transition"
                          title="View Blueprint Progress"
                          (click)="openBlueprintProgressModal(task)"
                          aria-label="View Blueprint Progress"
                        >
                          <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 text-blue-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 17v-2a2 2 0 012-2h2a2 2 0 012 2v2m-6 0h6m-6 0a2 2 0 01-2-2V7a2 2 0 012-2h6a2 2 0 012 2v8a2 2 0 01-2 2m-6 0v2a2 2 0 002 2h2a2 2 0 002-2v-2" />
                          </svg>
                        </button>
                      </ng-container>
                      <!-- Image Attachment Indicator -->
                      <ng-container *ngIf="task.media && task.media.length > 0">
                        <span 
                          class="inline-flex items-center px-2 py-1 rounded-full text-xs font-medium bg-purple-100 text-purple-800"
                          title="{{ task.media.length }} image(s) attached">
                          <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4 mr-1" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z" />
                          </svg>
                          {{ task.media.length }}
                        </span>
                      </ng-container>
                      <span 
                        *ngIf="task.flag !== 'white'"
                        class="inline-flex items-center px-2 py-1 rounded-full text-xs font-medium"
                        [ngClass]="{
                          'bg-red-500 text-white': task.flag === 'red',
                          'bg-yellow-500 text-white': task.flag === 'yellow',
                          'bg-green-500 text-white': task.flag === 'green'
                        }">
                        <ion-icon [name]="getFlagIcon(task.flag)" class="mr-1"></ion-icon>
                      </span>
                    </div>
                  </div>

                  <!-- Middle Row: Task Name -->
                  <div class="mb-1">
                    <h3 class="text-sm font-medium text-gray-900" 
                        [ngClass]="{'font-bold': !task.isRead}">
                      {{ task.request.name }}
                    </h3>
                  </div>

                  <!-- Bottom Row: From/Assigned To and Actions -->
                  <div class="flex items-center justify-between">
                    <p class="text-xs text-gray-500" [ngClass]="{'font-semibold': !task.isRead}">
                      <span *ngIf="activeFilter === 'IR'">From: {{ task.createdBy.name }}</span>
                      <span *ngIf="activeFilter === 'CTR' || activeFilter === 'MR'">Assigned To: {{ task.employee?.name }}</span>
                      <span *ngIf="activeFilter !== 'CTR' && activeFilter !== 'IR' && activeFilter !== 'MR'">From: {{ task.createdBy.name }}</span>
                    </p>
                    <div class="flex items-center space-x-2">
                      <button type="button" *ngIf="activeFilter === 'CTR'"
                              (click)="assignTaskToUser(task, true, $event)" 
                              class="bg-black text-white px-2 py-1 text-xs font-semibold rounded-md hover:bg-gray-800 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-black">
                        <fa-icon [icon]="faCheck" class="text-yellow-300 mr-1"></fa-icon>
                        Accept
                      </button>
                      <button (click)="openEditSlideOut(task, $event)" 
                              [attr.data-task]="task | json"
                              (touchstart)="startLongPress($event, task)"
                              (touchend)="endLongPress($event)"
                              (touchcancel)="cancelLongPress()"
                              (mousedown)="startLongPress($event, task)"
                              (mouseup)="endLongPress($event)"
                              (mouseleave)="cancelLongPress()"
                              (mouseenter)="showTooltip($event, task)"
                              (mouseleave)="onTooltipMouseLeave($event)"
                              type="button"
                              style="-webkit-touch-callout: none; touch-action: none;"
                              class="text-indigo-600 p-1 rounded-full hover:text-indigo-800 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500">
                        <fa-icon [icon]="faEye" class="fa-1.5x"></fa-icon>
                      </button>
                    </div>
                  </div>
                </div>

                <!-- Desktop Layout -->
                <div class="hidden md:flex items-center justify-between">
                  <!-- Left Section -->
                  <div class="flex items-center space-x-4 flex-grow max-w-[70%]">
                    <!-- Date and Status Indicators -->
                    <div class="flex items-center space-x-2 min-w-[100px] flex-shrink-0">
                      <span class="text-xs text-gray-500">{{ formatDate(task.createdAt) }}</span>
                      <!-- Status Indicators -->
                      <div class="flex items-center space-x-1">
                        <!-- Urgent Indicator -->
                        <span *ngIf="task.isUrgent" title="Urgent Request">
                        <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" viewBox="0 0 24 24" fill="red" stroke="black" stroke-width="2">
                          <circle cx="12" cy="12" r="10" stroke="black" stroke-width="2" fill="red" />
                          <line x1="12" y1="8" x2="12" y2="14" stroke="white" stroke-width="2" />
                          <line x1="12" y1="16" x2="12" y2="18" stroke="white" stroke-width="2" />
                        </svg>
                      </span>
                        <!-- Read/Unread Status -->
                        <span class="inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium"
                              [ngClass]="{
                                'bg-blue-100 text-blue-800': !task.isRead,
                                'bg-gray-100 text-gray-600': task.isRead
                              }">
                          <svg *ngIf="!task.isRead" xmlns="http://www.w3.org/2000/svg" class="h-3 w-3 mr-1" viewBox="0 0 20 20" fill="currentColor">
                            <path d="M10 12a2 2 0 100-4 2 2 0 000 4z" />
                            <path fill-rule="evenodd" d="M.458 10C1.732 5.943 5.522 3 10 3s8.268 2.943 9.542 7c-1.274 4.057-5.064 7-9.542 7S1.732 14.057.458 10zM14 10a4 4 0 11-8 0 4 4 0 018 0z" clip-rule="evenodd" />
                          </svg>
                          <svg *ngIf="task.isRead" xmlns="http://www.w3.org/2000/svg" class="h-3 w-3 mr-1" viewBox="0 0 20 20" fill="currentColor">
                            <path fill-rule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clip-rule="evenodd" />
                          </svg>
                          {{ task.isRead ? 'Read' : 'Unread' }}
                        </span>
                      </div>
                    </div>

                    <!-- Task Name and Assignee -->
                    <div class="flex-grow min-w-0">
                      <h3 class="text-sm font-medium text-gray-900 truncate" [ngClass]="{'font-bold': !task.isRead}">
                        {{ task.request.name }}
                      </h3>
                      <p class="text-xs text-gray-500 truncate">
                        <span *ngIf="activeFilter === 'IR'">From: {{ task.createdBy.name }}</span>
                        <span *ngIf="activeFilter === 'CTR' || activeFilter === 'MR'">Assigned To: {{ task.employee?.name }}</span>
                        <span *ngIf="activeFilter !== 'CTR' && activeFilter !== 'IR' && activeFilter !== 'MR'">From: {{ task.createdBy.name }}</span>
                      </p>
                    </div>

                    <!-- Sublets -->
                    <div *ngIf="task.subletVendorAssignments && task.subletVendorAssignments.length > 0" class="hidden md:flex items-center space-x-1 flex-shrink-0 ml-4">
                      <span 
                        *ngFor="let sublet of task.subletVendorAssignments"
                        class="inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium bg-blue-100 text-blue-800"
                        [ngClass]="{
                          'bg-teal-600 text-white hover:bg-teal-700 ring-teal-600': sublet.isAssigned,
                          'bg-blue-50 text-blue-700 hover:bg-blue-100 ring-blue-500': !sublet.isAssigned
                        }">
                          {{ sublet.subletName }} 
                      </span>
                    </div>
                  </div>
                  <!-- Right Section -->
                  <div class="flex items-center space-x-3 flex-shrink-0 ml-4">
                    <!-- Time Since Request -->
                    <span class="text-xs text-gray-500 whitespace-nowrap">{{ task.taskCompleted ? '----' : task.timeSinceRequest }}</span>
                    
                    <!-- Status Flag -->
                    <span 
                      *ngIf="task.flag !== 'white'"
                      class="inline-flex items-center px-2 py-1 rounded-full text-xs font-medium whitespace-nowrap"
                      [ngClass]="{
                        'bg-red-500 text-white': task.flag === 'red',
                        'bg-yellow-500 text-white': task.flag === 'yellow',
                        'bg-green-500 text-white': task.flag === 'green'
                      }">
                      <ion-icon [name]="getFlagIcon(task.flag)" class="mr-1"></ion-icon>
                    </span>

                    <!-- Image Attachment Indicator -->
                    <ng-container *ngIf="task.media && task.media.length > 0">
                      <span 
                        class="inline-flex items-center px-2 py-1 rounded-full text-xs font-medium whitespace-nowrap bg-purple-100 text-purple-800"
                        title="{{ task.media.length }} image(s) attached">
                        <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4 mr-1" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z" />
                        </svg>
                        {{ task.media.length }}
                      </span>
                    </ng-container>

                     <!-- Blueprint Progress Button -->
                    <ng-container *ngIf="task.request?.name === 'Blueprint' && user?.roles.includes('gm')">
                      <button
                        class="p-1 rounded-full bg-blue-100 hover:bg-blue-200 transition"
                        title="View Blueprint Progress"
                        (click)="openBlueprintProgressModal(task)"
                        aria-label="View Blueprint Progress"
                      >
                        <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 text-blue-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 17v-2a2 2 0 012-2h2a2 2 0 012 2v2m-6 0h6m-6 0a2 2 0 01-2-2V7a2 2 0 012-2h6a2 2 0 012 2v8a2 2 0 01-2 2m-6 0v2a2 2 0 002 2h2a2 2 0 002-2v-2" />
                        </svg>
                      </button>
                    </ng-container>
                    
                    <!-- Action Buttons -->
                    <button type="button" *ngIf="activeFilter === 'CTR'"
                            (click)="assignTaskToUser(task, true, $event)" 
                            class="bg-black text-white px-3 py-1 text-xs font-semibold rounded-md hover:bg-gray-800 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-black whitespace-nowrap">
                      <fa-icon [icon]="faCheck" class="text-yellow-300 mr-1"></fa-icon>
                      Accept
                    </button>
                    
                    <button (click)="openEditSlideOut(task, $event)" 
                            [attr.data-task]="task | json"
                            (touchstart)="startLongPress($event, task)"
                            (touchend)="endLongPress($event)"
                            (touchcancel)="cancelLongPress()"
                            (mousedown)="startLongPress($event, task)"
                            (mouseup)="endLongPress($event)"
                            (mouseleave)="cancelLongPress()"
                            (mouseenter)="showTooltip($event, task)"
                            (mouseleave)="onTooltipMouseLeave($event)"
                            type="button"
                            style="-webkit-touch-callout: none; touch-action: none;"
                            class="text-indigo-600 p-1 rounded-full hover:text-indigo-800 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500">
                      <fa-icon [icon]="faEye" class="fa-1.5x"></fa-icon>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Bottom pager — after finishing a page -->
          <div *ngIf="totalPages > 1"
               class="mb-4 mt-4 flex items-center justify-between rounded-lg border border-gray-200 bg-white px-4 py-3 shadow-sm">
            <button
              type="button"
              (click)="previousPage(true)"
              [disabled]="currentPage === 1 || isPaginationLoading"
              class="inline-flex items-center rounded-md px-4 py-2 text-sm font-medium transition-[transform,background-color] duration-150 ease-[cubic-bezier(0.23,1,0.32,1)] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-indigo-500 active:scale-[0.97] disabled:cursor-not-allowed disabled:active:scale-100"
              [ngClass]="{
                'bg-black text-white hover:bg-gray-800': currentPage !== 1 && !isPaginationLoading,
                'cursor-not-allowed bg-gray-100 text-gray-400': currentPage === 1 || isPaginationLoading
              }">
              <svg class="mr-2 h-5 w-5" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 19l-7-7 7-7" />
              </svg>
              Previous
            </button>

            <p class="tabular-nums text-sm text-gray-700" aria-live="polite">
              <span class="font-medium text-gray-900">{{ currentPage }}</span>
              <span class="mx-2 text-gray-400">/</span>
              <span>{{ totalPages }}</span>
            </p>

            <button
              type="button"
              (click)="nextPage(true)"
              [disabled]="currentPage === totalPages || isPaginationLoading"
              class="inline-flex items-center rounded-md px-4 py-2 text-sm font-medium transition-[transform,background-color] duration-150 ease-[cubic-bezier(0.23,1,0.32,1)] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-indigo-500 active:scale-[0.97] disabled:cursor-not-allowed disabled:active:scale-100"
              [ngClass]="{
                'bg-black text-white hover:bg-gray-800': currentPage !== totalPages && !isPaginationLoading,
                'cursor-not-allowed bg-gray-100 text-gray-400': currentPage === totalPages || isPaginationLoading
              }">
              Next
              <svg class="ml-2 h-5 w-5" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7" />
              </svg>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</main>

<!-- Overlay -->
<div *ngIf="slideOutVisible || slideOutVisible2 || slideOutVisible3 || slideOutVisible4" 
     class="fixed inset-0 bg-black bg-opacity-50 z-[70]">
</div>
  
<!-- Main Slideout -->
<div *ngIf="slideOutVisible" @slideInOut 
     class="fixed bottom-0 right-0 top-16 w-screen max-w-md overflow-y-auto bg-white shadow-xl z-[75]">
  <div class="h-full flex flex-col bg-white shadow-xl">
    <div class="px-4 py-3 bg-gray-50 sm:px-4">
      <div class="flex items-start justify-between">
        <h2 class="text-lg font-medium text-gray-900">New Request</h2>
        <div class="ml-3 h-7 flex items-center">
          <button (click)="toggleSlideOut()" class="bg-white rounded-md text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-indigo-500">
            <span class="sr-only">Close panel</span>
            <svg class="h-6 w-6" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>
      </div>
    </div>
    <div class="px-4 py-4 sm:px-6 flex-1">
      <form (ngSubmit)="onSubmit()" #taskForm="ngForm" class="space-y-4">
        <div>
          <label for="request" class="block text-sm font-medium text-gray-700">Request</label>
          <select id="request" name="request" [(ngModel)]="task.request" required class="appearance-none rounded relative block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 focus:z-10 sm:text-sm">
            <option value="" [selected]="task.request === ''">Select a request</option>
            <option *ngFor="let req of requests; trackBy: trackByRequestId" [value]="req._id">{{ req.name }}</option>
          </select>
        </div>
        <div>
          <label for="employee" class="block text-sm font-medium text-gray-700">Assign To</label>
          <select id="employee" name="employee" [(ngModel)]="task.employee" required class="appearance-none rounded relative block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 focus:z-10 sm:text-sm">
            <option value="" [selected]="task.employee === ''">Select an assignee</option>
            <!-- Users -->
            <optgroup label="Users">
              <option *ngFor="let req of filteredUsers" [value]="req._id">{{ req.name }}</option>
            </optgroup>
  
            <!-- Global Groups -->
            <optgroup label="Global Groups">
              <option *ngFor="let group of filteredGlobalGroups" [value]="group._id">{{ group.name }}</option>
            </optgroup>
  
            <!-- Private Groups -->
            <optgroup label="Private Groups">
              <option *ngFor="let group of filteredPrivateGroups" [value]="group._id">{{ group.name }}</option>
            </optgroup>
          </select>
        </div>
        <div>
          <label for="comments" class="block text-sm font-medium text-gray-700">Comments</label>
          <textarea id="comments" name="comments" [(ngModel)]="task.comments" required class="appearance-none rounded relative block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 focus:z-10 sm:text-sm h-36"></textarea>
        </div>

        <!-- Add Sublet Button -->
        <section *ngIf="user?.roles.includes('developer') || user?.roles.includes('estimator') || user?.roles.includes('gm')">
          <div class="mt-2" *ngIf="showAddSublet(task.request)">
            <button type="button" (click)="toggleSubletComponent()" class="group relative w-30 flex justify-center py-3 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-green-600 hover:bg-green-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-500">
            Add Sublet
            </button>
          </div>

         <!-- Selected Sublet Options Tags -->
          <div *ngIf="selectedSubletOptions.length > 0" class="mt-4 flex flex-wrap">
            <span 
              *ngFor="let option of selectedSubletOptions" 
              (click)="subletSelect(option)"
              class="mr-2 mb-2 inline-flex items-center px-3 py-1.5 rounded-full text-sm font-medium bg-indigo-100 text-indigo-800 hover:bg-indigo-200 transition-colors duration-200 ease-in-out select-none"
              style="cursor: pointer !important;"
            >
              {{ option.name }}
              <button 
                (click)="removeSubletOption(option); $event.stopPropagation()"
                type="button" 
                class="ml-2 h-4 w-4 inline-flex justify-center items-center rounded-full bg-indigo-200 text-indigo-500 hover:bg-indigo-400 hover:text-indigo-700 transition-colors duration-200 ease-in-out select-none"
                style="cursor: pointer !important;"
              >
                <span class="sr-only">Remove option</span>
                &times;
              </button>
            </span>
          </div>
        </section> 

        <div class="flex items-center space-y-2">
          <button
            type="button"
            class="relative inline-flex h-6 w-11 flex-shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:outline-none focus:ring-2 focus:ring-indigo-600 focus:ring-offset-2"
            role="switch"
            [attr.aria-checked]="task.isUrgent"
            [ngClass]="task.isUrgent ? 'bg-indigo-600' : 'bg-gray-200'"
            (click)="toggleUrgency()"
          >
            <span class="sr-only">Mark as Urgent</span>
            <span
              aria-hidden="true"
              class="pointer-events-none inline-block h-5 w-5 rounded-full bg-white shadow ring-0 transition duration-200 ease-in-out"
              [ngClass]="task.isUrgent ? 'translate-x-5' : 'translate-x-0'"
            ></span>
          </button>
          <label for="isUrgent" class="ml-2 block text-sm text-gray-900">Mark as Urgent</label>
        </div>
        
        <div class="space-y-2">
          <button type="submit" class="group relative w-full flex justify-center py-3 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500">
            Create Request
          </button>
        </div>
      </form>
    </div>
  </div>

    <lib-confirmation-modal-tw class="z-[9999]"
    [isOpen]="showDistroGroupTaskModal"
    [title]="'Choose Distribution Method'"
    [message]="distroMethodModalMessage"
    [confirmButtonText]="'Share with Group'"
    [cancelButtonText]="'Send Individually'"
    [type]="'approve'"
    (confirm)="distroGroupTask('shared')"
    (cancel)="distroGroupTask('individual')">
  </lib-confirmation-modal-tw>

</div>

<!-- Detail Slideout -->
<div *ngIf="slideOutVisible2" @slideInOut 
     class="fixed right-0 z-[80] w-full overflow-hidden bg-white shadow-xl md:w-2/3"
     style="top: 64px; bottom: 0;">


  <div class="flex h-full min-h-0 flex-col bg-white md:flex-row">

    <!-- First Column (Task Details) -->
    <div class="flex h-full min-h-0 w-full flex-col md:w-2/3">

      <!-- Identity -->
      <div class="flex-shrink-0 border-b border-gray-200 px-4 py-4">
        <div class="flex items-start justify-between gap-3">
          <h2 class="min-w-0 truncate text-lg font-semibold tracking-tight text-gray-900">
            {{ isEditMode ? 'Request: ' + requestName : 'New Request' }}
          </h2>
          <button type="button" (click)="toggleSlideOut()"
                  class="rounded-md p-2 text-gray-500 transition-colors hover:bg-gray-100 hover:text-gray-800 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-indigo-500">
            <span class="sr-only">Close panel</span>
            <svg class="h-5 w-5" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="1.75" aria-hidden="true">
              <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>

        <div class="mt-3 flex flex-wrap gap-2">
          <span *ngIf="updTask.flag && updTask.flag !== 'white'"
                class="inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-medium"
                [ngClass]="{
                  'bg-red-100 text-red-800': updTask.flag === 'red',
                  'bg-yellow-100 text-yellow-800': updTask.flag === 'yellow',
                  'bg-green-100 text-green-800': updTask.flag === 'green'
                }">
            {{ flagTextMap[updTask.flag] }}
          </span>
          <span class="inline-flex items-center rounded-full bg-emerald-100 px-2.5 py-0.5 text-xs font-medium text-emerald-800">
            {{ updTask.taskCompleted ? 'Completed' : 'In Progress' }}
          </span>
        </div>

        <p class="mt-2 text-sm text-gray-600">
          <span class="font-medium text-gray-800">{{ updTask.createdBy?.name }}</span>
          <span class="mx-1.5 text-gray-400" aria-hidden="true">•</span>
          <span>{{ formatDate(updTask.createdAt) }}</span>
        </p>
      </div>

      <form (ngSubmit)="onSubmit()" #taskForm="ngForm" class="flex min-h-0 flex-1 flex-col">
        <!-- Edit -->
        <div class="min-h-0 flex-1 space-y-5 overflow-y-auto px-4 py-4">
          <div>
            <label for="request" class="block text-sm font-medium text-gray-900">Request</label>
            <select id="request" name="request" [(ngModel)]="updTask.request" required
              class="mt-1.5 block w-full rounded-lg border-gray-300 text-sm text-gray-900 focus:border-indigo-500 focus:ring-indigo-500">
              <option value="" [selected]="isEmptyRequest(updTask.request)">Select a request</option>
              <option *ngFor="let req of requests; trackBy: trackByRequestId" [value]="req._id">{{ req.name }}</option>
            </select>
          </div>

          <div>
            <label for="employee" class="block text-sm font-medium text-gray-900">Assigned To</label>
            <select id="employee" name="employee" [(ngModel)]="updTask.employee" required
              class="mt-1.5 block w-full rounded-lg border-gray-300 text-sm text-gray-900 focus:border-indigo-500 focus:ring-indigo-500">
              <option value="" [selected]="isEmptyEmployee(updTask.employee)">Select an assignee</option>
              <optgroup label="Users">
                <option *ngFor="let req of filteredUsers" [value]="req._id">{{ req.name }}</option>
              </optgroup>
              <optgroup label="Global Groups">
                <option *ngFor="let group of filteredGlobalGroups" [value]="group._id">{{ group.name }}</option>
              </optgroup>
              <optgroup label="Private Groups">
                <option *ngFor="let group of filteredPrivateGroups" [value]="group._id">{{ group.name }}</option>
              </optgroup>
            </select>
          </div>

          <div *ngIf="taskLevelMediaStrip.length > 0 && showImageMediaUpload(updTask.request)">
            <p class="text-sm font-medium text-gray-900">Photos</p>
            <div class="mt-2 flex flex-wrap gap-2">
              <ng-container *ngFor="let media of taskLevelMediaStrip; let i = index; trackBy: trackByMediaId">
                <div class="relative h-24 w-24 overflow-hidden rounded-lg border border-gray-200 bg-gray-50">
                  <img [src]="getMediaImageUrl(media)"
                    [attr.data-media-id]="media.mediaId?._id"
                    alt="Task photo"
                    class="h-full w-full cursor-pointer object-cover transition-opacity duration-150 hover:opacity-80"
                    [style.transform]="'rotate(' + (media.rotation || 0) + 'deg)'"
                    (click)="openImageViewerTaskLevel(i)" />
                  <button type="button"
                    (click)="promptDeleteImage(media, $event)"
                    class="absolute right-1 top-1 rounded-full bg-white/90 p-1 text-red-700 transition hover:bg-red-50 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-indigo-500"
                    title="Delete Image"
                    aria-label="Delete photo">
                    <fa-icon [icon]="faTrash" class="text-xs"></fa-icon>
                  </button>
                </div>
              </ng-container>
            </div>
          </div>

          <div *ngIf="showAddSublet(updTask.request)" class="flex flex-wrap items-center gap-3">
            <span class="text-sm font-medium text-gray-900">Sublets</span>
            <button type="button" (click)="toggleSubletComponent()"
              class="rounded-lg bg-gray-900 px-3 py-1.5 text-sm font-medium text-white transition hover:bg-gray-800 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-indigo-500">
              Add / Edit Sublet(s)
            </button>
          </div>

          <div *ngIf="updTask.sublets && updTask.sublets.length" class="rounded-lg border border-gray-200 p-3">
            <div class="flex flex-wrap gap-2">
              <button
                *ngFor="let sublet of updTask.subletVendorAssignments || []"
                (click)="subletSelect(sublet); $event.stopPropagation()"
                type="button"
                class="inline-flex items-center rounded-full px-3 py-1.5 text-sm font-medium transition focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-indigo-500"
                [ngClass]="{
                  'bg-teal-700 text-white': sublet.isAssigned,
                  'bg-blue-50 text-blue-800 hover:bg-blue-100': !sublet.isAssigned
                }"
                [disabled]="!!sublet.isAssigned">
                {{ sublet.subletName }}
              </button>
            </div>
          </div>
        </div>

        <!-- Actions -->
        <div class="flex-shrink-0 border-t border-gray-200 bg-white px-4 py-3">
          <div class="flex flex-col gap-2">
            <div class="flex flex-col gap-2 sm:flex-row">
              <button *ngIf="activeFilter !='CTR' && activeFilter !='CSR' && activeFilter !='PR'"
                type="submit"
                [disabled]="updTask.taskCompleted"
                class="inline-flex h-11 flex-1 items-center justify-center rounded-lg bg-gray-900 px-4 text-sm font-semibold text-white transition-[transform,background-color] duration-150 ease-[cubic-bezier(0.23,1,0.32,1)] hover:bg-gray-800 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-indigo-500 focus-visible:ring-offset-2 active:scale-[0.97] disabled:cursor-not-allowed disabled:bg-gray-200 disabled:text-gray-500 disabled:active:scale-100">
                Update Request
              </button>
              <button *ngIf="activeFilter !='CTR' && activeFilter !='CSR' && activeFilter !='PR'"
                type="button"
                (click)="acknowledgeCompletion(updTask, $event)"
                [disabled]="updTask.taskCompleted"
                class="inline-flex h-11 flex-1 items-center justify-center rounded-lg border border-emerald-700 bg-white px-4 text-sm font-semibold text-emerald-800 transition-[transform,background-color] duration-150 ease-[cubic-bezier(0.23,1,0.32,1)] hover:bg-emerald-50 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-indigo-500 focus-visible:ring-offset-2 active:scale-[0.97] disabled:cursor-not-allowed disabled:border-gray-200 disabled:text-gray-400 disabled:active:scale-100">
                {{ updTask.taskCompleted ? 'Request Completed' : 'Complete Request' }}
              </button>

              <button *ngIf="activeFilter =='CSR'"
                type="button"
                [disabled]="!updTask.taskCompleted"
                (click)="acknowledgeCloseCSRTask($event)"
                class="inline-flex h-11 flex-1 items-center justify-center rounded-lg bg-gray-900 px-4 text-sm font-semibold text-white transition hover:bg-gray-800 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-indigo-500 disabled:cursor-not-allowed disabled:bg-gray-200 disabled:text-gray-500">
                Close Request
              </button>
              <button *ngIf="activeFilter =='PR'"
                type="button"
                [disabled]="!updTask.taskCompleted"
                (click)="acknowledgeClosePorterTask($event)"
                class="inline-flex h-11 flex-1 items-center justify-center rounded-lg bg-gray-900 px-4 text-sm font-semibold text-white transition hover:bg-gray-800 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-indigo-500 disabled:cursor-not-allowed disabled:bg-gray-200 disabled:text-gray-500">
                Close Request
              </button>
              <button *ngIf="activeFilter =='CTR'"
                type="button"
                (click)="assignTaskToUser(updTask, true)"
                class="inline-flex h-11 flex-1 items-center justify-center rounded-lg bg-gray-900 px-4 text-sm font-semibold text-white transition hover:bg-gray-800 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-indigo-500">
                Assign Request To Me
              </button>
            </div>

            <button type="button"
              class="inline-flex h-10 w-full items-center justify-center rounded-lg border border-gray-300 bg-white px-4 text-sm font-medium text-gray-800 transition hover:bg-gray-50 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-indigo-500 md:hidden"
              (click)="openEditCommentView(updTask, isEditMode)">
              Show Comments
            </button>

            <div class="flex flex-wrap items-center justify-between gap-2 pt-1">
              <button *ngIf="isAllowedToAssign"
                type="button"
                (click)="assignTaskToUser(updTask, false)"
                class="text-sm font-medium text-gray-700 underline-offset-2 hover:underline focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-indigo-500">
                Unassign Request
              </button>
              <button *ngIf="activeFilter !='CTR'"
                type="button"
                [disabled]="updTask.taskCompleted || activeFilter =='CSR' || activeFilter =='PR'"
                (click)="acknowledgeDeleteTask($event)"
                class="ml-auto text-sm font-medium text-red-700 underline-offset-2 transition hover:underline focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-indigo-500 disabled:cursor-not-allowed disabled:text-gray-400 disabled:no-underline">
                Delete Request
              </button>
            </div>
          </div>
        </div>
      </form>
    </div>

    <!-- Second Column (Comments) -->
    <div class="hidden h-full min-h-0 w-full flex-col border-l border-gray-200 p-4 md:flex md:w-1/3">
      <lib-comment-thread
        class="min-h-0 flex-1"
        composerId="desktop-comment-draft"
        [comments]="sortedUpdTaskComments"
        [loading]="loadingComments"
        [draft]="updTask.comments || ''"
        [disabled]="!!updTask.taskCompleted"
        (draftChange)="updTask.comments = $event"
        (send)="onSubmit(false)">
      </lib-comment-thread>
    </div>
  </div>

  <lib-confirmation-modal-tw class="z-[9999]"
    [isOpen]="showDeleteImageModal"
    [title]="'Delete Image'"
    [message]="'Are you sure you want to delete this image?'"
    [confirmButtonText]="'Delete'"
    [cancelButtonText]="'Cancel'"
    [type]="'reject'"
    (confirm)="deleteImageFromTask()"
    (cancel)="closeDeleteImageModal()">
  </lib-confirmation-modal-tw>

  <lib-confirmation-modal-tw class="z-[9999]"
    [isOpen]="showCompleteTaskModal"
    [title]="'Complete Request'"
    [message]="'Are you sure you want to complete this request ?'"
    [confirmButtonText]="'Complete'"
    [cancelButtonText]="'Cancel'"
    [type]="'approve'"
    (confirm)="completeTask(updTask)"
    (cancel)="closeCompleteTaskModal()">
  </lib-confirmation-modal-tw>

  <lib-confirmation-modal-tw class="z-[9999]"
    [isOpen]="showDeleteTaskModal"
    [title]="'Delete Request'"
    [message]="'Are you sure you want to delete this request ?'"
    [confirmButtonText]="'Delete'"
    [cancelButtonText]="'Cancel'"
    [type]="'reject'"
    (confirm)="deleteTask(updTask)"
    (cancel)="closeDeleteTaskModal()">
  </lib-confirmation-modal-tw>

  <lib-confirmation-modal-tw class="z-[9999]"
    [isOpen]="showCloseCSRTaskModal"
    [title]="'Close Request'"
    [message]="'Are you sure you want to close this request ?'"
    [confirmButtonText]="'Close'"
    [cancelButtonText]="'Cancel'"
    [type]="'approve'"
    (confirm)="closeCSRTask(updTask)"
    (cancel)="closeCSRTaskModal()">
  </lib-confirmation-modal-tw>

  <lib-confirmation-modal-tw class="z-[9999]"
    [isOpen]="showDistroGroupTaskModal"
    [title]="'Choose Distribution Method'"
    [message]="distroMethodModalMessage"
    [confirmButtonText]="'Share with Group'"
    [cancelButtonText]="'Send Individually'"
    [type]="'approve'"
    (confirm)="distroGroupTask('shared')"
    (cancel)="distroGroupTask('individual')">
  </lib-confirmation-modal-tw>

</div>


<div *ngIf="slideOutVisible3" @slideInOut 
     class="fixed right-0 z-[85] flex w-full flex-col bg-white shadow-xl md:w-2/3"
     style="top: 64px; bottom: 0;">
  <lib-comment-thread
    class="min-h-0 flex-1 p-4"
    composerId="mobile-comment-draft"
    [showHeader]="true"
    [title]="requestName"
    [comments]="sortedUpdTaskComments"
    [loading]="loadingComments"
    [draft]="updTask.comments || ''"
    [disabled]="!!updTask.taskCompleted"
    (draftChange)="updTask.comments = $event"
    (send)="onSubmit(false)"
    (close)="closeEditCommentView($event)">
  </lib-comment-thread>
</div>

<!-- Vendor Associate Slideout -->
<div *ngIf="slideOutVisible4" @slideInOut
     class="fixed right-0 w-full md:w-2/3 bg-white shadow-xl z-[90] overflow-y-auto" 
     style="top: 64px; bottom: 0;">
  <lib-vendor-associate 
    [taskId]="updTask?._id || null" 
    [taskMedia]="updTask?.media || []"
    (slideOutToggled)="toggleVendorSlideOut()" 
    [subletSelected]="subletSelected">
  </lib-vendor-associate>
</div>

<!-- Invite Vendor Modal -->
<div
  *ngIf="isInviteVendorModalVisible"
  class="fixed inset-0 flex items-center justify-center z-50 bg-black bg-opacity-50"
>
  <div class="bg-white w-full md:w-1/2 lg:w-1/3 rounded-lg shadow-lg p-6">
    <!-- Modal Header -->
    <div class="flex items-center justify-between mb-4 border-b pb-2">
      <h2 class="text-xl font-semibold text-gray-900">Invite A Vendor</h2>
      <button
        class="text-gray-500 hover:text-gray-700 focus:outline-none"
        (click)="closeInviteVendorModal()"
      >
        ✕
      </button>
    </div>

    <!-- Modal Content -->
    <form [formGroup]="inviteVendorForm" (ngSubmit)="submitInviteVendor()">
       <!-- Vendor Category Dropdown -->
       <div class="mb-4">
        <label class="block text-sm font-medium text-gray-700 mb-1">Vendor Category</label>
        <select
        formControlName="servicesOffered"
        class="w-full border border-gray-300 rounded-md p-2 focus:ring-indigo-500 focus:border-indigo-500"
        >
        <option value="" selected>Select a category</option>
        <option *ngFor="let category of vendorCategories" [value]="category.value">
            {{category.label}}
        </option>
        </select>
        <div *ngIf="inviteVendorForm.get('servicesOffered')?.invalid && inviteVendorForm.get('servicesOffered')?.touched" 
             class="text-red-500 text-sm mt-1">
          Category is required
        </div>
    </div>
      <!-- Contact Name -->
      <div class="mb-4">
        <label class="block text-sm font-medium text-gray-700 mb-1">Contact Name <span class="text-red-500">*</span></label>
        <input
          formControlName="contactName"
          type="text"
          placeholder="Enter contact name"
          class="w-full border border-gray-300 rounded-md p-2 focus:ring-indigo-500 focus:border-indigo-500 placeholder-gray-500"
        />
        <div *ngIf="inviteVendorForm.get('contactName')?.invalid && inviteVendorForm.get('contactName')?.touched" class="text-red-500 text-sm mt-1">
          Contact name is required.
        </div>
      </div>

      <!-- Vendor Name -->
      <div class="mb-4">
        <label class="block text-sm font-medium text-gray-700 mb-1">Vendor Name</label>
        <input
          formControlName="vendorName"
          type="text"
          placeholder="Enter vendor name"
          class="w-full border border-gray-300 rounded-md p-2 focus:ring-indigo-500 focus:border-indigo-500 placeholder-gray-500"
        />
      </div>

      <!-- Phone Number (Required) -->
      <div class="mb-4">
        <label class="block text-sm font-medium text-gray-700 mb-1">Phone Number <span class="text-red-500">*</span></label>
        <input
          formControlName="phoneNumber"
          type="tel"
          placeholder="Enter phone number"
          class="w-full border border-gray-300 rounded-md p-2 focus:ring-indigo-500 focus:border-indigo-500 placeholder-gray-500"
        />
        <div *ngIf="inviteVendorForm.get('phoneNumber')?.invalid && inviteVendorForm.get('phoneNumber')?.touched" class="text-red-500 text-sm mt-1">
          Phone number is required.
        </div>
      </div>

      <!-- Email Address -->
      <div class="mb-4">
        <label class="block text-sm font-medium text-gray-700 mb-1">Email Address</label>
        <input
          formControlName="emailAddress"
          type="email"
          placeholder="Enter email address"
          class="w-full border border-gray-300 rounded-md p-2 focus:ring-indigo-500 focus:border-indigo-500 placeholder-gray-500"
        />
      </div>

      <!-- Modal Actions -->
      <div class="flex justify-end space-x-2">
        <button
          type="button"
          class="px-4 py-2 bg-gray-300 text-gray-700 rounded-md hover:bg-gray-400 focus:outline-none"
          (click)="closeInviteVendorModal()"
        >
          Cancel
        </button>
        <button
          type="submit"
          class="px-4 py-2 bg-green-600 text-white rounded-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
          [disabled]="inviteVendorForm.invalid"
        >
          Submit
        </button>
      </div>
    </form>
  </div>
</div>

<app-sublet-selection *ngIf="subletService.showSublet$ | async" (closeSublet)="toggleSubletComponent()"></app-sublet-selection>

<app-comment-tooltip
  [comments]="activeTooltipTask?.commentMsg || []"
  [isVisible]="tooltipVisible"
  [position]="tooltipPosition"
  [requestName]="activeTooltipTask?.request?.name"
  (mouseenter)="onTooltipMouseEnter()"
  (mouseleave)="onTooltipMouseLeave($event)">
</app-comment-tooltip>

<!-- Styles moved to dashboard.component.css -->

<lib-distribution-groups-manager
  [isOpen]="showDistributionGroupsManager"
  [tenantId]="getTenantContext()"
  (closed)="showDistributionGroupsManager = false"
  (groupsChanged)="reloadDistributionGroupsFromManager()">
</lib-distribution-groups-manager>
